import React, { useState, useRef, useEffect } from 'react';
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink, Font, Svg, Line, Rect   } from '@react-pdf/renderer';
import ReactPDF from '@react-pdf/renderer';
import '../shared/fonts';

const styles = StyleSheet.create({
  page: {
    fontFamily:"iransans",
    flexDirection: 'row',
    backgroundColor: '#ffffff'
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  tableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomWidth: 1,
    borderRightWidth: 1,
  },
  tableCell: {
    margin: 5,
    fontSize: 10,
  },
  
});

export default function  PrintGradeSheetDescriptional(props){
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const margin = 25;
  const courseColWidth = 150;
  const dataColWidth = 210;
  const mainRowHeight = 60;
  const dataRowHeight = 120;
  const headeRowHeight = 35;

  const gradeSheets = props.data;
  const pdfSize = [4*dataColWidth+1+courseColWidth+2*margin, 2*mainRowHeight + 2* headeRowHeight + 10*dataRowHeight+ 4 * 20 + 2 * margin];
  const emptyRows = Array.from({length:(10-gradeSheets[0].courses.length)});

  useEffect(() => {
     
  }, []);
  return(
    <Document key={"doc_"}>
      {
        gradeSheets.map((gs, pageIndex)=>{
          return(
            <Page size={pdfSize} style={styles.page} key={"page_" + gs.id}>
              <View style={{position:"absolute", width:pdfSize[0]-2*margin, height:mainRowHeight*2, left:margin, top:margin}}>
                <View style={{position:"absolute", fontFamily:"iransans", top:0, left:0, width:dataColWidth, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"right", fontSize:"9", direction:"rtl"}}>کلاس</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}> </Text>
                  <Text style={{position:"relative", textAlign:"right", fontSize:"9", direction:"rtl"}}>{util.toPersianDigits(gs.schoolClass.name)}</Text>
                </View>
                <View style={{position:"absolute", fontFamily:"iransans", top:mainRowHeight, left:0, width:dataColWidth, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"right", fontSize:"9", direction:"rtl"}}></Text>
                </View>

                <View style={{position:"absolute", fontFamily:"iransans", top:0, left:dataColWidth, width:dataColWidth, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"right", fontSize:"9", direction:"rtl"}}>سال تحصیلی</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}> </Text>
                  <Text style={{position:"relative", textAlign:"right", fontSize:"10", direction:"rtl"}}>{util.getEducationName()}</Text>
                </View>
                <View style={{position:"absolute", fontFamily:"iransans", top:mainRowHeight, left:dataColWidth, width:dataColWidth, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"right", fontSize:"9", direction:"rtl"}}>رشته-پایه</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}> </Text>
                  <Text style={{position:"relative", textAlign:"right", fontSize:"10", direction:"rtl"}}>{util.toPersianDigits(gs.schoolClass.field.title + " - " + util.getDegreeChar(gs.schoolClass.degree))}</Text>
                </View>

                <View style={{position:"absolute", fontFamily:"iransans", top:0, left:dataColWidth*2, width:dataColWidth, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}>مدرسه</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}> </Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"11", direction:"rtl"}}>{util.toPersianDigits(util.getSchoolName())}</Text>
                </View>
                <View style={{position:"absolute", fontFamily:"iransans", top:mainRowHeight, left:dataColWidth*2, width:dataColWidth, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}>نام ولی</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}> </Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"11", direction:"rtl"}}>{gs.student.parent == null? "": (gs.student.parent.firstname + " " + gs.student.parent.lastname)}</Text>
                </View>

                 <View style={{position:"absolute", fontFamily:"iransans", top:0, left:dataColWidth*3, width:dataColWidth+courseColWidth, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"11", fontWeight:"bold", direction:"rtl"}}>کارنامه توصیفی</Text>
                </View>
                <View style={{position:"absolute", fontFamily:"iransans", top:mainRowHeight, left:dataColWidth*3, width:dataColWidth+courseColWidth, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}>نام و نام خانوادگی</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}> </Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"11", direction:"rtl"}}>{gs.student.firstname + " " + gs.student.lastname}</Text>
                </View> 
              </View>
              <View style={{position:"absolute", backgroundColor:"#444644ff", width:pdfSize[0]-2*margin, height:headeRowHeight, left:margin, top:margin+2*mainRowHeight}}>
                <View style={{position:"absolute", fontFamily:"iransans", top:0, left:0, width:dataColWidth, height:headeRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl", color:"#FFF"}}>نیاز به تلاش بیشتر</Text>
                </View>
                <View style={{position:"absolute", fontFamily:"iransans", top:0, left:dataColWidth*1, width:dataColWidth, height:headeRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl", color:"#FFF"}}>قابل قبول</Text>
                </View>
                <View style={{position:"absolute", fontFamily:"iransans", top:0, left:dataColWidth*2, width:dataColWidth, height:headeRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl", color:"#FFF"}}>خوب</Text>
                </View>
                <View style={{position:"absolute", fontFamily:"iransans", top:0, left:dataColWidth*3, width:dataColWidth, height:headeRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl", color:"#FFF"}}>خیلی خوب</Text>
                </View>
                <View style={{position:"absolute", fontFamily:"iransans", top:0, left:dataColWidth*4, width:courseColWidth, height:headeRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl", color:"#FFF"}}>نام درس</Text>
                </View>
              </View>
              {
                gs.courses.map((course, courseInd)=>{
                  return(
                    <View style={{position:"absolute", backgroundColor:(courseInd%2 == 0?"#fff" : "#f6f6f6"), width:pdfSize[0]-2*margin, height:dataRowHeight, left:margin, top:(courseInd*dataRowHeight) +(margin+(2*mainRowHeight)) + headeRowHeight}}>
                      
                      <View style={{position:"absolute", overflow:"hidden", fontFamily:"iransans", top:0, left:0, width:dataColWidth, height:dataRowHeight, border:"1px solid #000", justifyContent:"flex-start",alignItems: "flex-end"}}>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"7", direction:"rtl", color:"#000"}}>
                          نقاط قوت: 
                            {
                              course.descriptions.map((desc, descInd)=>{
                                return(
                                  <>
                                    {
                                      (desc.isValid)&&(desc.positiveCommentRejected != "")?
                                      <>
                                        {util.getMonthName(desc.monthNo) + ":" + desc.positiveCommentRejected}
                                      </>
                                      :
                                      <>
                                      </>                              
                                    }
                                  </>
                                )
                              })
                            }
                        </Text>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"7", direction:"rtl", color:"#000"}}>
                          نقاط ضعف: 
                            {
                              course.descriptions.map((desc, descInd)=>{
                                return(
                                  <>
                                    {
                                      (desc.isValid)&&(desc.negativeCommentRejected != "")?
                                      <>
                                        {util.getMonthName(desc.monthNo) + ":" + desc.negativeCommentRejected}
                                      </>
                                      :
                                      <>
                                      </>                              
                                    }
                                  </>
                                )
                              })
                            }
                        </Text>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"7", direction:"rtl", color:"#000"}}>
                          پیشنهاد: 
                            {
                              course.descriptions.map((desc, descInd)=>{
                                return(
                                  <>
                                    {
                                      (desc.isValid)&&(desc.recommendationRejected != "")?
                                      <>
                                        {util.getMonthName(desc.monthNo) + ":" + desc.recommendationRejected}
                                      </>
                                      :
                                      <>
                                      </>                              
                                    }
                                  </>
                                )
                              })
                            }
                        </Text>
                      </View>
                       <View style={{position:"absolute", fontFamily:"iransans", top:0, left:dataColWidth*1, width:dataColWidth, height:dataRowHeight, border:"1px solid #000", justifyContent:"flex-start",alignItems: "flex-end"}}>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"7", direction:"rtl", color:"#000"}}>
                          نقاط قوت: 
                            {
                              course.descriptions.map((desc, descInd)=>{
                                return(
                                  <>
                                    {
                                      (desc.isValid)&&(desc.positiveCommentAcceptable != "")?
                                      <>
                                        {util.getMonthName(desc.monthNo) + ":" + desc.positiveCommentAcceptable}
                                      </>
                                      :
                                      <>
                                      </>                              
                                    }
                                  </>
                                )
                              })
                            }
                        </Text>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"7", direction:"rtl", color:"#000"}}>
                          نقاط ضعف: 
                            {
                              course.descriptions.map((desc, descInd)=>{
                                return(
                                  <>
                                    {
                                      (desc.isValid)&&(desc.negativeCommentAcceptable != "")?
                                      <>
                                        {util.getMonthName(desc.monthNo) + ":" + desc.negativeCommentAcceptable}
                                      </>
                                      :
                                      <>
                                      </>                              
                                    }
                                  </>
                                )
                              })
                            }
                        </Text>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"7", direction:"rtl", color:"#000"}}>
                          پیشنهاد: 
                            {
                              course.descriptions.map((desc, descInd)=>{
                                return(
                                  <>
                                    {
                                      (desc.isValid)&&(desc.recommendationAcceptable != "")?
                                      <>
                                        {util.getMonthName(desc.monthNo) + ":" + desc.recommendationAcceptable}
                                      </>
                                      :
                                      <>
                                      </>                              
                                    }
                                  </>
                                )
                              })
                            }
                        </Text>
                      </View>
                      <View style={{position:"absolute", fontFamily:"iransans", top:0, left:dataColWidth*2, width:dataColWidth, height:dataRowHeight, border:"1px solid #000", justifyContent:"flex-start",alignItems: "flex-end"}}>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"7", direction:"rtl", color:"#000"}}>
                          نقاط قوت: 
                            {
                              course.descriptions.map((desc, descInd)=>{
                                return(
                                  <>
                                    {
                                      (desc.isValid)&&(desc.positiveCommentGood != "")?
                                      <>
                                        {util.getMonthName(desc.monthNo) + ":" + desc.positiveCommentGood}
                                      </>
                                      :
                                      <>
                                      </>                              
                                    }
                                  </>
                                )
                              })
                            }
                        </Text>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"7", direction:"rtl", color:"#000"}}>
                          نقاط ضعف: 
                            {
                              course.descriptions.map((desc, descInd)=>{
                                return(
                                  <>
                                    {
                                      (desc.isValid)&&(desc.negativeCommentGood != "")?
                                      <>
                                        {util.getMonthName(desc.monthNo) + ":" + desc.negativeCommentGood}
                                      </>
                                      :
                                      <>
                                      </>                              
                                    }
                                  </>
                                )
                              })
                            }
                        </Text>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"7", direction:"rtl", color:"#000"}}>
                          پیشنهاد: 
                            {
                              course.descriptions.map((desc, descInd)=>{
                                return(
                                  <>
                                    {
                                      (desc.isValid)&&(desc.recommendationGood != "")?
                                      <>
                                        {util.getMonthName(desc.monthNo) + ":" + desc.recommendationGood}
                                      </>
                                      :
                                      <>
                                      </>                              
                                    }
                                  </>
                                )
                              })
                            }
                        </Text>
                      </View>
                      <View style={{position:"absolute", fontFamily:"iransans", top:0, left:dataColWidth*3, width:dataColWidth, height:dataRowHeight, border:"1px solid #000", justifyContent:"flex-start",alignItems: "flex-end"}}>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"7", direction:"rtl", color:"#000"}}>
                          نقاط قوت: 
                            {
                              course.descriptions.map((desc, descInd)=>{
                                return(
                                  <>
                                    {
                                      (desc.isValid)&&(desc.positiveCommentVeryGood != "")?
                                      <>
                                        {util.getMonthName(desc.monthNo) + ":" + desc.positiveCommentVeryGood}
                                      </>
                                      :
                                      <>
                                      </>                              
                                    }
                                  </>
                                )
                              })
                            }
                        </Text>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"7", direction:"rtl", color:"#000"}}>
                          نقاط ضعف: 
                            {
                              course.descriptions.map((desc, descInd)=>{
                                return(
                                  <>
                                    {
                                      (desc.isValid)&&(desc.negativeCommentVeryGood != "")?
                                      <>
                                        {util.getMonthName(desc.monthNo) + ":" + desc.negativeCommentVeryGood}
                                      </>
                                      :
                                      <>
                                      </>                              
                                    }
                                  </>
                                )
                              })
                            }
                        </Text>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"7", direction:"rtl", color:"#000"}}>
                          پیشنهاد: 
                            {
                              course.descriptions.map((desc, descInd)=>{
                                return(
                                  <>
                                    {
                                      (desc.isValid)&&(desc.recommendationVeryGood != "")?
                                      <>
                                        {util.getMonthName(desc.monthNo) + ":" + desc.recommendationVeryGood}
                                      </>
                                      :
                                      <>
                                      </>                              
                                    }
                                  </>
                                )
                              })
                            }
                        </Text>
                      </View> 
                      <View style={{position:"absolute", fontFamily:"iransans", top:0, left:dataColWidth*4, width:courseColWidth, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl", color:"#000"}}>{course.course.name}</Text>
                      </View>
                    </View>
                  )
                })
              }
              {
                emptyRows.map((r, emptyInd)=>{
                  return(
                    <View style={{position:"absolute", width:pdfSize[0]-2*margin, height:dataRowHeight, left:margin, top:((gs.courses.length + emptyInd)*dataRowHeight) +(margin+2*mainRowHeight + headeRowHeight)}}>
                      <View style={{position:"absolute", fontFamily:"iransans", top:0, left:0, width:dataColWidth, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl", color:"#000"}}></Text>
                      </View>
                      <View style={{position:"absolute", fontFamily:"iransans", top:0, left:dataColWidth*1, width:dataColWidth, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl", color:"#000"}}></Text>
                      </View>
                      <View style={{position:"absolute", fontFamily:"iransans", top:0, left:dataColWidth*2, width:dataColWidth, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl", color:"#000"}}></Text>
                      </View>
                      <View style={{position:"absolute", fontFamily:"iransans", top:0, left:dataColWidth*3, width:dataColWidth, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl", color:"#000"}}></Text>
                      </View>
                      <View style={{position:"absolute", fontFamily:"iransans", top:0, left:dataColWidth*4, width:courseColWidth, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl", color:"#000"}}></Text>
                      </View>
                    </View>
                  )
                })
              }
              
              <View style={{position:"absolute", borderTop:"2px dashed #888", width:pdfSize[0]-2*margin, height:50, left:margin, top:pdfSize[1]-margin-60}}>
                <View style={{position:"absolute", top:0, right:margin, width:200, height:dataRowHeight, justifyContent:"flex-start",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}>مدیر آموزشگاه</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}>{gs.manager.firstname + " " + gs.manager.lastname}</Text>
                </View>
              </View>
            </Page>
          )
        })
      }
    </Document>  
  )
}
